"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyLogoType = void 0;
var CompanyLogoType;
(function (CompanyLogoType) {
    CompanyLogoType["FULL"] = "full";
    CompanyLogoType["SQUARE"] = "square";
})(CompanyLogoType || (exports.CompanyLogoType = CompanyLogoType = {}));
//# sourceMappingURL=companyLogoType.enum.js.map